import type { Neighborhood } from '@/config/objects/neighborhoods';
import { useOutletContext } from 'react-router-dom';

interface NeighborhoodContext {
  neighborhood: Neighborhood | undefined;
  isLoading: boolean;
}

export function useNeighborhoodContext() {
  return useOutletContext<NeighborhoodContext>();
}
